import { FC } from 'react';

import { CategoriesData, TestData } from '../types';
import { renderCovidTestListItemMobile } from './render';
import { ImageUrl } from '../constants/image-urls';
import { covidSubCategoryId } from '../constants/tests';
import { useSearchStore } from '../stores/search';
import { sortTestsByNumber } from '../helpers/sort-tests-by-number';
import Fuse from 'fuse.js';

interface SubCategoryAccordionProps {
  category: CategoriesData;
  isSearching: boolean;
  subCategoriesMap: { [key: string]: boolean };
  testsMap: { [key: string]: boolean };
  categoryIndex: number;
  results?: Fuse.FuseResult<TestData>[];
}

export const ResultsWithoutAccordion: FC<SubCategoryAccordionProps> = (
  {
    category,
    isSearching,
    subCategoriesMap,
    testsMap,
    categoryIndex
  }): JSX.Element => {
  
  const { isAlphabetSearch } = useSearchStore((state) => state);
  
  return (
    <div className="">
      {category.subCategories.map((subCategory, index) => (
        (!isSearching || subCategoriesMap[subCategory.id]) && (
          <div
            key={`${category.id}-${subCategory.id}-accordion`}
            className={``}
          >
            <div id={subCategory.id}>
              <div
                className="genica_acc_content">
                <div className={`tests-box ${!isAlphabetSearch && category.subCategories.length > 1 ? 'mb-5' : 'mt-0'} `}>
                  {subCategory.tests.map((test, testIndex) => {
                    return (
                      (!isSearching || testsMap[test.id]) && (
                        <a href={`/test/${test.slug}`} key={testIndex}
                           data-w-id="eabe16cf-6688-4182-9962-4a07cd774e31"
                           className="test-link desktop w-full striped">
                          <div className={`row-background`}>
                            <div className="w-layout-grid table-row-grid  all two-columns">
                              <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e34-634ceff9"
                                   className="table-row-content">
                                <div className="name text-left">
                                  {test.name}
                                </div>
                              </div>
                              
                              <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e3a-634ceff9"
                                   className="table-row-content price">
                                <div className="price">
                                  {(test.price?.length || test.price) && (
                                    <span>{test.price?.replace('лева', '').trim()} лв.</span>
                                  )}
                                  
                                  {/*// @ts-ignore*/}
                                  {test.price.length === 0 && (
                                    <span>-</span>
                                  )}
                                
                                </div>
                              </div>
                              
                              <div className="info-icon">
                                <img style={{ display: 'block', opacity: 1 }}
                                     loading="lazy"
                                     src={ImageUrl.INFO_ICON} alt=""
                                     className="normal"/><img
                                style={{ opacity: 0, display: 'none' }} loading="lazy"
                                src={ImageUrl.INFO_ICON_HOVER}
                                alt="" className="hover"/></div>
                            </div>
                          </div>
                        </a>
                      )
                    );
                  })}
                  
                  {/**/}
                </div>
                
                <div className="tests-cards-grid">
                  {subCategory.id === covidSubCategoryId && (
                    renderCovidTestListItemMobile(sortTestsByNumber(subCategory.tests))
                  )}
                  
                  {subCategory.tests.map((test, testIndex) => (
                    (!isSearching || testsMap[test.id]) && subCategory.id !== covidSubCategoryId && (
                      <a
                        href={`/test/${test.slug}`} key={testIndex}
                        data-w-id="6cf0a404-3286-5840-aeaf-25e81d8c0532"
                        className="test-link-card price w-block">
                        <div className="test-card-content-top">
                          <h3 className="title test-title text-left">
                            {test.name}
                          </h3>
                          <div className="info-icon"><img
                            // style="display:block;opacity:1"
                            loading="lazy"
                            src={ImageUrl.INFO_ICON}
                            alt=""
                            className="normal"/><img
                            // style="opacity:0;display:none"
                            loading="lazy"
                            src={ImageUrl.INFO_ICON_HOVER}
                            alt="" className="hover"/></div>
                        </div>
                        
                        <div className="test-details">
                          <div className="test-price-tag ">
                            <div className="card-image-box h-5">
                              <img width="16" src={ImageUrl.PRICE_ICON} alt=""
                                   className="image"/>
                            </div>
                            <div className="price-number">
                              {(test.price?.length || test.price) && (
                                <span>{test.price?.replace('лева', '').trim()} лв.</span>
                              )}
                              {/*// @ts-ignore*/}
                              {test.price.length === 0 && (
                                <span>-</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </a>
                    )
                  ))}
                </div>
              </div>
            </div>
          </div>
        )))}
    </div>
  );
};
